(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    


  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-lookbook-b"] && !window.DesignMode) return;
  try {
    "use strict";!function(){function t(){var e=document.querySelectorAll(".qq-shop-the-look-grid .QQ-JS-init-msg");e&&e.forEach(function(e){e.remove()})}var o;function n(){(o=document.getElementsByClassName("qq-shop-the-look-grid")).length&&i()}function i(){if(o.length)for(var e=0;e<o.length;e++){var t=o[e].id,n=t.replace("shopify-section-","qq-video-cover-");!document.getElementById(n)||(n=document.getElementById(n))&&n.addEventListener("click",function(e){e.preventDefault(),function(e,t){document.getElementById(e).style.display="none";t=document.getElementById(t);void 0!==t&&null!=t&&t.play()}(this.id,this.getAttribute("data-vidID"))}),function(e){e=$("#"+e+" .qq-responsive-video-container");e.length&&e.each(function(e){var t;$(this).hasClass("qq-portrait")&&(t=1.33*$(this).outerWidth(!0),$(this).css("height",t))})}(t)}}window.addEventListener("shopify:section:load",function(e){t()}),t(),"loading"!==document.readyState?n():document.addEventListener("DOMContentLoaded",function(){n()}),window.addEventListener("shopify:section:load",function(e){n()}),window.addEventListener("shopify:block:select",function(e){i()})}();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
